import { getOrderFulfillmentCTA } from "./shared";
export var AddressAndPhoneNumber = function AddressAndPhoneNumber(strictLocalize) {
  return {
    titleBuilder: function titleBuilder() {
      return reimbursementOfShippingCostBuilder(strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder() {
      return reimbursementOfShippingCostBuilder(strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getOrderFulfillmentC;
        return (_getOrderFulfillmentC = getOrderFulfillmentCTA(context, strictLocalize)) === null || _getOrderFulfillmentC === void 0 ? void 0 : _getOrderFulfillmentC.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getOrderFulfillmentC2, _getOrderFulfillmentC3;
        return (_getOrderFulfillmentC2 = getOrderFulfillmentCTA(context, strictLocalize)) === null || _getOrderFulfillmentC2 === void 0 ? void 0 : (_getOrderFulfillmentC3 = _getOrderFulfillmentC2.getLink) === null || _getOrderFulfillmentC3 === void 0 ? void 0 : _getOrderFulfillmentC3.call(_getOrderFulfillmentC2);
      }
    }
  };
};
var reimbursementOfShippingCostBuilder = function reimbursementOfShippingCostBuilder(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return strictLocalize({
        id: "uNzg15",
        defaultMessage: [{
          "type": 0,
          "value": "Modifier le numéro de téléphone sur la page de traitement des commandes"
        }]
      });
    },
    getDescription: function getDescription() {
      return [strictLocalize({
        id: "1f8FkR",
        defaultMessage: [{
          "type": 0,
          "value": "Selon votre problème et le statut de votre colis, vous pourrez peut-être corriger l'adresse ou le numéro de téléphone alors que la commande est en cours de traitement. Vous pouvez modifier l'adresse d'expédition de la commande à l'étape « 2. Adresse d'expédition » sur la page de traitement des commandes."
        }]
      }), strictLocalize({
        id: "xnaL/E",
        defaultMessage: [{
          "type": 0,
          "value": "Parfois, il peut s'agir d'une faute de frappe ou d'une espace en trop. Si l'adresse du commerçant n'est pas valide, vous pouvez lui envoyer un message ou un e-mail directement sur sa page client. Si le problème persiste, veuillez nous contacter."
        }]
      })];
    }
  };
};